import { Box, Typography, Button, IconButton, styled, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { RightArrowIcon, LeftArrowIcon } from "../../components-new/icons";
import { useEffect, useState } from "react";

const StyledIconBtn = styled(IconButton)`
  border-radius: 0;
  padding: 10px;

  &:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;

const StepText = styled("span")`
  padding-left: 30px;
  padding-right: 30px;
`;

const EditHeader = ({
  editItemIndex: currentEditItemIndex,
  setEditItemIndex,
  EditData: testCasesList,
  fromStepHistory,
  testCase,
  onExit,
}) => {
  // const testCasesList = useSelector((state) => state.executionSlice.testCaseResults);
  const editItem = testCasesList[currentEditItemIndex];
  const [disableIncrement, setDisableIncrement] = useState(false);
  const [disableDecrement, setDisableDecrement] = useState(false);

  useEffect(() => {
    updateButtonDisableStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEditItemIndex, testCasesList]);

  const updateButtonDisableStatus = () => {
    if (currentEditItemIndex !== -1) {
      setDisableIncrement(currentEditItemIndex === testCasesList?.length - 1);
      setDisableDecrement(currentEditItemIndex === 0);
    } else {
      setDisableIncrement(true);
      setDisableDecrement(true);
    }
  };

  const handleIncrementStep = () => {
    if (currentEditItemIndex !== -1) {
      if (currentEditItemIndex + 1 < testCasesList.length) {
        setEditItemIndex(currentEditItemIndex + 1);
      } else {
        console.log("End of test cases list reached");
      }
    }
  };

  const handleDecrementStep = () => {
    if (currentEditItemIndex !== -1) {
      if (currentEditItemIndex - 1 >= 0) {
        setEditItemIndex(currentEditItemIndex - 1);
      } else {
        console.log("Beginning of test cases list reached");
      }
    }
  };

  const handleBack = () => {
    if (onExit) {
      onExit();
      return;
    }
    setEditItemIndex(null);
  };
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        position: "sticky",
        top: 16,
        zIndex: 1000,
        backgroundColor: "#ffffff",
        padding: "24px 0",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <Box>
        <Typography color="#000000" fontSize="25px" fontWeight={600}>
          <Tooltip title="Go to previous step">
            <StyledIconBtn
              variant="text"
              aria-label="Previous step"
              disabled={disableDecrement}
              onClick={handleDecrementStep}
            >
              <LeftArrowIcon />
            </StyledIconBtn>
          </Tooltip>
          <StepText>
            Step {editItem.Step_Number} {fromStepHistory && `@ ${editItem.Executed_Date}`}
          </StepText>
          <Tooltip title="Go to next step">
            <StyledIconBtn
              aria-label="Next step"
              disabled={disableIncrement}
              onClick={handleIncrementStep}
            >
              <RightArrowIcon />
            </StyledIconBtn>
          </Tooltip>
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" columnGap="12px" textAlign="right">
        <Tooltip title="Exit and return to step list">
          <Button
            variant="contained"
            sx={{
              textTransform: "capitalize",
              padding: "10px 20px",
              borderRadius: "6px",
              fontSize: "14px",
              backgroundColor: "#ff5336",
              color: "#ffffff",
              "&:hover": {
                backgroundColor: "#e64a2e",
              },
            }}
            startIcon={<ArrowBackIcon />}
            onClick={handleBack}
          >
            Exit
          </Button>
        </Tooltip>
      </Box>
    </Box>
  );
};
export default EditHeader;
